import {useActivitiesStore} from '~src/stores/activities/ActivitiesStore'
import {useActivitiesRuntimeStore} from '~/stores/activities/ActivitiesRuntimeStore'
import {usePersistentStore} from '~/stores/PersistentStore'
import {useCarsRentStore} from '~/stores/carsRent/СarsRentStore'
import {useCarsRentRuntimeStore} from '~/stores/carsRent/CarsRentRuntimeStore'
import {useRuntimeStore} from '~src/stores/RuntimeStore'
import {useHotelsStore} from '~/stores/hotels/HotelsStore'
import {useHotelsRuntimeStore} from '~src/stores/hotels/HotelsRuntimeStore'
import {useFlightsRuntimeStore} from '~src/stores/flights/FlightsRuntimeStore'
import {useFlightsStore} from '~/stores/flights/FlightsStore'
import {usePackagesStore} from '~/stores/packages/PackagesStore'
import {usePackagesRuntimeStore} from '~/stores/packages/PackagesRuntimeStore'
import {useCruisesStore} from '~/stores/cruises/CruisesStore'
import {useCruisesRuntimeStore} from '~/stores/cruises/CruisesRuntimeStore'
import {useToursStore} from '~/stores/tours/ToursStore'
import {useToursRuntimeStore} from '~/stores/tours/ToursRuntimeStore'
import {useTransfersStore} from '~/stores/transfers/TransfersStore'
import {useTransfersRuntimeStore} from '~/stores/transfers/TransfersRuntimeStore'
import {useAdminRuntimeStore} from '~/stores/AdminRuntimeStore'
import {useExtraServicesStore} from '~/stores/extraServices/ExtraServicesStore'
import {useExtraServicesRuntimeStore} from '~/stores/extraServices/ExtraServicesRuntimeStore'
import {useInsuranceStore} from '~/stores/insurance/InsuranceStore'
import {useInsuranceRuntimeStore} from '~/stores/insurance/InsuranceRuntimeStore'
import {useVisaStore} from '~/stores/visa/VisaStore'
import {useVisaRuntimeStore} from '~/stores/visa/VisaRuntimeStore'
import {useSupplierStore} from '~/stores/SupplierStore'
import {useSimpleTourStore} from '~/stores/simpleTours/SimpleTourStore'
import {useSimpleTourRuntimeStore} from '~/stores/simpleTours/SimpleTourRuntimeStore'

let cmsStore: Omit<ReturnType<typeof useCmsStore>, keyof ReturnType<typeof defineStore>>
let weatherStore: Omit<ReturnType<typeof useWeatherStore>, keyof ReturnType<typeof defineStore>>
let adminRuntimeStore: Omit<ReturnType<typeof useAdminRuntimeStore>, keyof ReturnType<typeof defineStore>>
let authStore: Omit<ReturnType<typeof useAuthStore>, keyof ReturnType<typeof defineStore>>

let activitiesStore: Omit<ReturnType<typeof useActivitiesStore>, keyof ReturnType<typeof defineStore>>
let activitiesRuntimeStore: Omit<ReturnType<typeof useActivitiesRuntimeStore>, keyof ReturnType<typeof defineStore>>
let hotelsStore: Omit<ReturnType<typeof useHotelsStore>, keyof ReturnType<typeof defineStore>>
let hotelsRuntimeStore: Omit<ReturnType<typeof useHotelsRuntimeStore>, keyof ReturnType<typeof defineStore>>
let flightsStore: Omit<ReturnType<typeof useFlightsStore>, keyof ReturnType<typeof defineStore>>
let flightsRuntimeStore: Omit<ReturnType<typeof useFlightsRuntimeStore>, keyof ReturnType<typeof defineStore>>

let carsRentStore: Omit<ReturnType<typeof useCarsRentStore>, keyof ReturnType<typeof defineStore>>
let carsRentRuntimeStore: Omit<ReturnType<typeof useCarsRentRuntimeStore>, keyof ReturnType<typeof defineStore>>

let extraServicesStore: Omit<ReturnType<typeof useExtraServicesStore>, keyof ReturnType<typeof defineStore>>
let extraServicesRuntimeStore: Omit<
    ReturnType<typeof useExtraServicesRuntimeStore>,
    keyof ReturnType<typeof defineStore>
>

let cruisesStore: Omit<ReturnType<typeof useCruisesStore>, keyof ReturnType<typeof defineStore>>
let cruisesRuntimeStore: Omit<ReturnType<typeof useCruisesRuntimeStore>, keyof ReturnType<typeof defineStore>>

let persistentStore: Omit<ReturnType<typeof usePersistentStore>, keyof ReturnType<typeof defineStore>>
let runtimeStore: Omit<ReturnType<typeof useRuntimeStore>, keyof ReturnType<typeof defineStore>>

let packagesStore: Omit<ReturnType<typeof usePackagesStore>, keyof ReturnType<typeof defineStore>>
let packagesRuntimeStore: Omit<ReturnType<typeof usePackagesRuntimeStore>, keyof ReturnType<typeof defineStore>>
let toursStore: Omit<ReturnType<typeof useToursStore>, keyof ReturnType<typeof defineStore>>
let toursRuntimeStore: Omit<ReturnType<typeof useToursRuntimeStore>, keyof ReturnType<typeof defineStore>>

let transfersStore: Omit<ReturnType<typeof useTransfersStore>, keyof ReturnType<typeof defineStore>>
let transfersRuntimeStore: Omit<ReturnType<typeof useTransfersRuntimeStore>, keyof ReturnType<typeof defineStore>>

let insuranceStore: Omit<ReturnType<typeof useInsuranceStore>, keyof ReturnType<typeof defineStore>>
let insuranceRuntimeStore: Omit<ReturnType<typeof useInsuranceRuntimeStore>, keyof ReturnType<typeof defineStore>>

let visaStore: Omit<ReturnType<typeof useVisaStore>, keyof ReturnType<typeof defineStore>>
let visaRuntimeStore: Omit<ReturnType<typeof useVisaRuntimeStore>, keyof ReturnType<typeof defineStore>>

let simpleTourStore: Omit<ReturnType<typeof useSimpleTourStore>, keyof ReturnType<typeof defineStore>>
let simpleTourRuntimeStore: Omit<ReturnType<typeof useSimpleTourRuntimeStore>, keyof ReturnType<typeof defineStore>>

let supplierStore: Omit<ReturnType<typeof useSupplierStore>, keyof ReturnType<typeof defineStore>>

export const initialiseStores = () => {
    cmsStore = useCmsStore(usePinia())
    weatherStore = useWeatherStore(usePinia())
    adminRuntimeStore = useAdminRuntimeStore(usePinia())
    authStore = useAuthStore(usePinia())

    activitiesStore = useActivitiesStore(usePinia())
    activitiesRuntimeStore = useActivitiesRuntimeStore(usePinia())
    carsRentStore = useCarsRentStore(usePinia())
    carsRentRuntimeStore = useCarsRentRuntimeStore(usePinia())
    cruisesStore = useCruisesStore(usePinia())
    cruisesRuntimeStore = useCruisesRuntimeStore(usePinia())
    hotelsStore = useHotelsStore(usePinia())
    hotelsRuntimeStore = useHotelsRuntimeStore(usePinia())
    flightsStore = useFlightsStore(usePinia())
    flightsRuntimeStore = useFlightsRuntimeStore(usePinia())
    packagesStore = usePackagesStore(usePinia())
    packagesRuntimeStore = usePackagesRuntimeStore(usePinia())
    toursStore = useToursStore(usePinia())
    toursRuntimeStore = useToursRuntimeStore(usePinia())
    transfersStore = useTransfersStore(usePinia())
    transfersRuntimeStore = useTransfersRuntimeStore(usePinia())
    extraServicesStore = useExtraServicesStore(usePinia())
    extraServicesRuntimeStore = useExtraServicesRuntimeStore(usePinia())
    insuranceStore = useInsuranceStore(usePinia())
    insuranceRuntimeStore = useInsuranceRuntimeStore(usePinia())
    visaStore = useVisaStore(usePinia())
    visaRuntimeStore = useVisaRuntimeStore(usePinia())
    simpleTourStore = useSimpleTourStore(usePinia())
    simpleTourRuntimeStore = useSimpleTourRuntimeStore(usePinia())
    supplierStore = useSupplierStore(usePinia())

    persistentStore = usePersistentStore(usePinia())
    runtimeStore = useRuntimeStore(usePinia())

    return {
        cmsStore,
        weatherStore,
        adminRuntimeStore,
        authStore,
        activitiesStore,
        activitiesRuntimeStore,
        carsRentStore,
        carsRentRuntimeStore,
        cruisesStore,
        cruisesRuntimeStore,
        hotelsStore,
        hotelsRuntimeStore,
        flightsStore,
        flightsRuntimeStore,
        persistentStore,
        runtimeStore,
        packagesStore,
        packagesRuntimeStore,
        toursStore,
        toursRuntimeStore,
        transfersStore,
        transfersRuntimeStore,
        extraServicesStore,
        extraServicesRuntimeStore,
        insuranceStore,
        insuranceRuntimeStore,
        visaStore,
        visaRuntimeStore,
        simpleTourStore,
        simpleTourRuntimeStore,
        supplierStore,
    }
}

export {
    cmsStore,
    weatherStore,
    adminRuntimeStore,
    authStore,
    activitiesStore,
    activitiesRuntimeStore,
    carsRentStore,
    carsRentRuntimeStore,
    cruisesStore,
    cruisesRuntimeStore,
    hotelsStore,
    hotelsRuntimeStore,
    flightsStore,
    flightsRuntimeStore,
    persistentStore,
    runtimeStore,
    packagesStore,
    packagesRuntimeStore,
    toursStore,
    toursRuntimeStore,
    transfersStore,
    transfersRuntimeStore,
    extraServicesStore,
    extraServicesRuntimeStore,
    insuranceStore,
    insuranceRuntimeStore,
    visaStore,
    visaRuntimeStore,
    simpleTourStore,
    simpleTourRuntimeStore,
    supplierStore,
}

if (import.meta.hot) {
    import.meta.hot.on('vite:afterUpdate', () => {
        initialiseStores()
    })
}
